import { UiState } from '@marketplace-web/shared/ui-helpers'
import { getNewPriceRange } from '_libs/utils/catalog'
import { DynamicFilterModel } from 'types/models/dynamic-filter'

import { DynamicFiltersState } from '../types'
import { DynamicFilterAction, DynamicFilterReducerAction } from './actionTypes'

export const dynamicFiltersReducer = (
  state: DynamicFiltersState,
  action: DynamicFilterAction,
): DynamicFiltersState => {
  switch (action.type) {
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTERS_REQUEST:
    case DynamicFilterReducerAction.FETCH_DEFAULT_DYNAMIC_FILTERS_REQUEST:
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_SEARCH_REQUEST:
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_REQUEST: {
      return { ...state, ui: { ...state.ui, uiState: UiState.Pending } }
    }
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTERS_SUCCESS: {
      return {
        ...state,
        dynamicFilters: action.payload.dynamicFilters,
        selectedDynamicFilters: action.payload.selectedDynamicFilters,
        ui: { ...state.ui, uiState: UiState.Success, errors: [] },
      }
    }
    case DynamicFilterReducerAction.FETCH_TEMPORARY_DYNAMIC_FILTERS_SUCCESS: {
      return {
        ...state,
        dynamicFilters: action.payload.dynamicFilters,
        temporarySelectedDynamicFilters: action.payload.temporarySelectedDynamicFilters,
        ui: { ...state.ui, uiState: UiState.Success, errors: [] },
      }
    }
    case DynamicFilterReducerAction.FETCH_DEFAULT_DYNAMIC_FILTERS_SUCCESS: {
      return {
        ...state,
        selectedDefaultFilters: action.payload.selectedDefaultFilters,
      }
    }
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_SUCCESS: {
      return {
        ...state,
        filterFacetsCount: action.payload.totalCount,
        filterFacetsCountMax: action.payload.totalCountMax,
      }
    }
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTERS_FAILURE:
    case DynamicFilterReducerAction.FETCH_DEFAULT_DYNAMIC_FILTERS_FAILURE:
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_SEARCH_FAILURE:
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_FAILURE: {
      return {
        ...state,
        ui: { ...state.ui, uiState: UiState.Failure, errors: action.payload.errors },
      }
    }
    case DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_SEARCH_SUCCESS: {
      const { code, options, isSelectionHighlighted } = action.payload
      const dynamicFilters = [...state.dynamicFilters]
      const filterIndex = dynamicFilters.findIndex(filter => filter.type === code)

      if (filterIndex !== -1) {
        const existingFilter = dynamicFilters[filterIndex]

        if (existingFilter) {
          const updatedFilter: DynamicFilterModel = {
            ...existingFilter,
            options,
            isSelectionHighlighted:
              isSelectionHighlighted ?? existingFilter.isSelectionHighlighted ?? false,
          }

          dynamicFilters[filterIndex] = updatedFilter
        }
      }

      return {
        ...state,
        dynamicFilters,
      }
    }
    case DynamicFilterReducerAction.SET_SELECTED_DYNAMIC_FILTERS: {
      return { ...state, selectedDynamicFilters: action.payload.selectedDynamicFilters }
    }
    case DynamicFilterReducerAction.SET_TEMPORARY_SELECTED_DYNAMIC_FILTERS: {
      return {
        ...state,
        temporarySelectedDynamicFilters: action.payload.temporarySelectedDynamicFilters,
      }
    }
    case DynamicFilterReducerAction.SET_TEMPORARY_CATALOG_IDS:
    case DynamicFilterReducerAction.UPDATE_TEMPORARY_CATALOG_IDS: {
      return { ...state, temporaryCatalogIds: action.payload.temporaryCatalogIds }
    }
    case DynamicFilterReducerAction.SET_TEMPORARY_PRICE_RANGE: {
      const { priceTo, priceFrom } = action.payload.priceRange
      const newPriceRange = getNewPriceRange(priceFrom, priceTo)

      return {
        ...state,
        temporaryPriceRange: {
          priceFrom: newPriceRange.priceFrom,
          priceTo: newPriceRange.priceTo,
        },
      }
    }
    case DynamicFilterReducerAction.SET_FILTER_SEARCH_QUERY: {
      return {
        ...state,
        filterSearchQuery: { text: action.payload.text, code: action.payload.code },
      }
    }
    case DynamicFilterReducerAction.SET_DYNAMIC_FILTER_FACETS: {
      return {
        ...state,
        filterFacetsCount: action.payload.filterFacetsCount,
      }
    }
    default:
      return state
  }
}
